import React, { ReactNode } from 'react';
import UiFieldWrapper from './UiFieldWrapper';
import UiBaseField from './UiBaseField';
import { InputAdornment, FormControl, InputLabel, FormHelperText } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import { getFieldData } from './UiFieldHelpers';
export type IPropsUiTextField = UiBaseField & {
    type?:string,
    prefix?: string | ReactNode,
    suffix?: string | ReactNode,
    placeholder?: string,
    fullWidth?: boolean
}
export const UiTextField = (props: IPropsUiTextField) => {

    const {error, name, value, onChange} = getFieldData(props);
    const label=(!props.inline) ? props.label : undefined;
    const prefix=(props.prefix) ? (<InputAdornment position="start">{props.prefix}</InputAdornment>) : ''
    const suffix=(props.suffix) ? (<InputAdornment position="end">{props.suffix}</InputAdornment>) : ''
    
    return (
        <React.Fragment>
            <UiFieldWrapper name="ui-text-field" {...props}>
                {props.inline && (
                    <div className="ui-field__label">{props.label}</div>
                )}
                <span className="ui-text-field__field ui-field__field">
                    <FormControl fullWidth variant="outlined">
                        {!props.inline && (
                            <InputLabel error={error.hasError}>{label}</InputLabel>
                        )}
                        <OutlinedInput
                            id={props.id}
                            fullWidth={props.fullWidth===false ? false : true}
                            label={label}
                            type={props.type}
                            value={value}
                            disabled={props.disabled}
                            name={name}
                            placeholder={props.placeholder}
                            onChange={onChange}
                            error={error.hasError}
                            startAdornment={prefix}
                            endAdornment={suffix}
                            onFocus={props.onFocus}
                            onBlur={props.onBlur}
                        />
                        {error.hasError && (
                            <FormHelperText error={error.hasError}>{ error.errorMessage }</FormHelperText>
                        )}

                    </FormControl>
                    
                </span>
            </UiFieldWrapper>
        </React.Fragment>
    )
}
export default UiTextField